const ADD_PAYPAL_PAYMENT_TYPE_REQUEST = 'ADD_PAYPAL_PAYMENT_TYPE_REQUEST';
const CLEAR_SERVICE_ERROR = 'CLEAR_SERVICE_ERROR';
const GET_PROMO_FINANCING_OFFERS = 'GET_PROMO_FINANCING_OFFERS';
const GET_PROMO_FINANCING_OFFERS_SUCCESS = 'GET_PROMO_FINANCING_OFFERS_SUCCESS';
const HANDLE_ORDER_PAYMENT_INFO = 'HANDLE_ORDER_PAYMENT_INFO';
const PATCH_SELECTED_PROMO_FINANCING_OFFER = 'PATCH_SELECTED_PROMO_FINANCING_OFFER';
const POST_SELECTED_REWARD_OR_FINANCING_OFFER = 'POST_SELECTED_REWARD_OR_FINANCING_OFFER';
const SET_REWARD_PROMO_FINANCE_DECISION = 'SET_REWARD_PROMO_FINANCE_DECISION';

export {
    ADD_PAYPAL_PAYMENT_TYPE_REQUEST,
    CLEAR_SERVICE_ERROR,
    GET_PROMO_FINANCING_OFFERS_SUCCESS,
    GET_PROMO_FINANCING_OFFERS,
    HANDLE_ORDER_PAYMENT_INFO,
    PATCH_SELECTED_PROMO_FINANCING_OFFER,
    POST_SELECTED_REWARD_OR_FINANCING_OFFER,
    SET_REWARD_PROMO_FINANCE_DECISION,
};
